
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailTemplateForm } from "@/components/admin/email/EmailTemplateForm";
import { EmailTestTool } from "@/components/admin/email/EmailTestTool";
import { EmailListIdSettings } from "@/components/admin/email/EmailListIdSettings";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

export function EmailSettings() {
  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Email Instellingen</h1>
      
      <div className="mb-8 space-y-8">
        <EmailTestTool />
        
        <Separator className="my-6" />
        
        <EmailListIdSettings />
      </div>
      
      <Tabs defaultValue="welcome">
        <TabsList className="mb-4">
          <TabsTrigger value="welcome">Welkom Email</TabsTrigger>
          <TabsTrigger value="verification">Verificatie Email</TabsTrigger>
          <TabsTrigger value="reset_password">Wachtwoord Reset</TabsTrigger>
        </TabsList>
        
        <Card>
          <CardHeader>
            <CardTitle>Email Template Bewerken</CardTitle>
            <CardDescription>
              Pas de inhoud en instellingen van email templates aan
            </CardDescription>
          </CardHeader>
          <CardContent>
            <TabsContent value="welcome">
              <EmailTemplateForm templateType="welcome" />
            </TabsContent>
            
            <TabsContent value="verification">
              <EmailTemplateForm templateType="verification" />
            </TabsContent>
            
            <TabsContent value="reset_password">
              <EmailTemplateForm templateType="reset_password" />
            </TabsContent>
          </CardContent>
        </Card>
      </Tabs>
    </div>
  );
}

export default EmailSettings;
